module.exports = __webpack_public_path__ + "media/video-loop-xl.fc3296cc.mp4";